module.exports = __webpack_public_path__ + "media/images/icons/ic-arrow-down-6decfee1c73e76a637f9460df800fefe.svg";